import { assign, setup } from 'xstate';
import type { BusTimesEvent } from './events';

export type BusDirection = {
  id: string;
  name: string;
  stops: ReadonlyArray<{ id: string; name: string; times: ReadonlyArray<string> }>;
};

export type BusRoute = {
  id: string;
  name: string;
  shortName: string;
  directions: ReadonlyArray<BusDirection>;
};

export type ScheduledArrival = {
  scheduledAt: string;
  minutesUntil: number;
};

/** A compact weekday timetable, deliberately kept as local product data. */
export const BUS_ROUTES: ReadonlyArray<BusRoute> = [
  {
    id: 'rapidride-e',
    name: 'RapidRide E Line',
    shortName: 'E Line',
    directions: [
      {
        id: 'rapidride-e-north',
        name: 'Aurora Village',
        stops: [
          {
            id: 'e-3rd-pine',
            name: '3rd Ave & Pine St',
            times: [
              '06:12',
              '06:27',
              '06:42',
              '07:00',
              '07:18',
              '07:36',
              '07:54',
              '08:12',
              '08:30',
              '08:48',
              '09:06',
              '09:24',
              '09:42',
              '10:00',
              '10:20',
              '10:40',
              '11:00',
              '11:20',
              '11:40',
              '12:00',
              '12:20',
              '12:40',
              '13:00',
              '13:20',
              '13:40',
              '14:00',
              '14:20',
              '14:40',
              '15:00',
              '15:20',
              '15:40',
              '16:00',
              '16:20',
              '16:40',
              '17:00',
              '17:20',
              '17:40',
              '18:00',
              '18:20',
              '18:40',
              '19:00',
              '19:20',
              '19:40',
              '20:00',
              '20:20',
              '20:40',
              '21:00',
              '21:20',
              '21:40',
              '22:00',
            ],
          },
          {
            id: 'e-aurora-85',
            name: 'Aurora Ave N & N 85th St',
            times: [
              '06:31',
              '06:46',
              '07:01',
              '07:19',
              '07:37',
              '07:55',
              '08:13',
              '08:31',
              '08:49',
              '09:07',
              '09:25',
              '09:43',
              '10:01',
              '10:21',
              '10:41',
              '11:01',
              '11:21',
              '11:41',
              '12:01',
              '12:21',
              '12:41',
              '13:01',
              '13:21',
              '13:41',
              '14:01',
              '14:21',
              '14:41',
              '15:01',
              '15:21',
              '15:41',
              '16:01',
              '16:21',
              '16:41',
              '17:01',
              '17:21',
              '17:41',
              '18:01',
              '18:21',
              '18:41',
              '19:01',
              '19:21',
              '19:41',
              '20:01',
              '20:21',
              '20:41',
              '21:01',
              '21:21',
              '21:41',
              '22:01',
            ],
          },
        ],
      },
      {
        id: 'rapidride-e-downtown',
        name: 'Downtown Seattle',
        stops: [
          {
            id: 'e-aurora-145',
            name: 'Aurora Ave N & N 145th St',
            times: [
              '05:58',
              '06:18',
              '06:38',
              '06:58',
              '07:18',
              '07:38',
              '07:58',
              '08:18',
              '08:38',
              '08:58',
              '09:18',
              '09:38',
              '09:58',
              '10:18',
              '10:38',
              '10:58',
              '11:18',
              '11:38',
              '11:58',
              '12:18',
              '12:38',
              '12:58',
              '13:18',
              '13:38',
              '13:58',
              '14:18',
              '14:38',
              '14:58',
              '15:18',
              '15:38',
              '15:58',
              '16:18',
              '16:38',
              '16:58',
              '17:18',
              '17:38',
              '17:58',
              '18:18',
              '18:38',
              '18:58',
              '19:18',
              '19:38',
              '19:58',
              '20:18',
              '20:38',
              '20:58',
              '21:18',
              '21:38',
              '21:58',
            ],
          },
          {
            id: 'e-3rd-pine-south',
            name: '3rd Ave & Pine St',
            times: [
              '06:20',
              '06:40',
              '07:00',
              '07:20',
              '07:40',
              '08:00',
              '08:20',
              '08:40',
              '09:00',
              '09:20',
              '09:40',
              '10:00',
              '10:20',
              '10:40',
              '11:00',
              '11:20',
              '11:40',
              '12:00',
              '12:20',
              '12:40',
              '13:00',
              '13:20',
              '13:40',
              '14:00',
              '14:20',
              '14:40',
              '15:00',
              '15:20',
              '15:40',
              '16:00',
              '16:20',
              '16:40',
              '17:00',
              '17:20',
              '17:40',
              '18:00',
              '18:20',
              '18:40',
              '19:00',
              '19:20',
              '19:40',
              '20:00',
              '20:20',
              '20:40',
              '21:00',
              '21:20',
              '21:40',
              '22:00',
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'route-44',
    name: 'Route 44',
    shortName: '44',
    directions: [
      {
        id: 'route-44-ballard',
        name: 'Ballard',
        stops: [
          {
            id: '44-uw',
            name: 'University District Station',
            times: [
              '06:05',
              '06:35',
              '07:05',
              '07:35',
              '08:05',
              '08:35',
              '09:05',
              '09:35',
              '10:05',
              '10:35',
              '11:05',
              '11:35',
              '12:05',
              '12:35',
              '13:05',
              '13:35',
              '14:05',
              '14:35',
              '15:05',
              '15:35',
              '16:05',
              '16:35',
              '17:05',
              '17:35',
              '18:05',
              '18:35',
              '19:05',
              '19:35',
              '20:05',
              '20:35',
              '21:05',
              '21:35',
              '22:05',
            ],
          },
        ],
      },
      {
        id: 'route-44-uw',
        name: 'University District',
        stops: [
          {
            id: '44-ballard',
            name: 'Ballard Ave NW & Market St',
            times: [
              '06:15',
              '06:45',
              '07:15',
              '07:45',
              '08:15',
              '08:45',
              '09:15',
              '09:45',
              '10:15',
              '10:45',
              '11:15',
              '11:45',
              '12:15',
              '12:45',
              '13:15',
              '13:45',
              '14:15',
              '14:45',
              '15:15',
              '15:45',
              '16:15',
              '16:45',
              '17:15',
              '17:45',
              '18:15',
              '18:45',
              '19:15',
              '19:45',
              '20:15',
              '20:45',
              '21:15',
              '21:45',
              '22:15',
            ],
          },
        ],
      },
    ],
  },
] as const;

export type BusTimesContext = {
  routes: ReadonlyArray<BusRoute>;
  directions: ReadonlyArray<BusDirection>;
  stops: ReadonlyArray<{ id: string; name: string; times: ReadonlyArray<string> }>;
  selectedRouteId: string | null;
  selectedDirectionId: string | null;
  selectedStopId: string | null;
  arrivals: ReadonlyArray<ScheduledArrival>;
  scheduleArrivals: ReadonlyArray<ScheduledArrival>;
  serviceDate: string | null;
  refreshedAt: string | null;
};

const STORAGE_KEY = 'seattle-bus-times.selection';
const PACIFIC = 'America/Los_Angeles';

function selectionIsValid(context: BusTimesContext): boolean {
  const route = context.routes.find((item) => item.id === context.selectedRouteId);
  const direction = route?.directions.find((item) => item.id === context.selectedDirectionId);
  return Boolean(direction?.stops.some((item) => item.id === context.selectedStopId));
}

function selectedStop(context: BusTimesContext) {
  const route = context.routes.find((item) => item.id === context.selectedRouteId);
  const direction = route?.directions.find((item) => item.id === context.selectedDirectionId);
  return direction?.stops.find((item) => item.id === context.selectedStopId);
}

function pacificParts(date: Date) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: PACIFIC,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const value = (type: string) => Number(parts.find((part) => part.type === type)?.value);
  return {
    year: value('year'),
    month: value('month'),
    day: value('day'),
    hour: value('hour') % 24,
    minute: value('minute'),
  };
}

function pacificDate(year: number, month: number, day: number, hour: number, minute: number): Date {
  const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute));
  const actual = pacificParts(utcGuess);
  const actualAsUtc = Date.UTC(actual.year, actual.month - 1, actual.day, actual.hour, actual.minute);
  return new Date(utcGuess.getTime() - (actualAsUtc - utcGuess.getTime()));
}

function upcomingArrivals(context: BusTimesContext, now = new Date()): ReadonlyArray<ScheduledArrival> {
  const stop = selectedStop(context);
  if (!stop) return [];
  const current = pacificParts(now);
  const today = Date.UTC(current.year, current.month - 1, current.day);
  const candidates: Date[] = [];
  for (let dayOffset = 0; dayOffset <= 7 && candidates.length < 3; dayOffset += 1) {
    const day = new Date(today + dayOffset * 86_400_000);
    const year = day.getUTCFullYear();
    const month = day.getUTCMonth() + 1;
    const date = day.getUTCDate();
    for (const time of stop.times) {
      const [hour, minute] = time.split(':').map(Number);
      const candidate = pacificDate(year, month, date, hour, minute);
      if (candidate.getTime() > now.getTime()) candidates.push(candidate);
      if (candidates.length === 3) break;
    }
  }
  return candidates.map((date) => ({
    scheduledAt: date.toISOString(),
    minutesUntil: Math.max(1, Math.ceil((date.getTime() - now.getTime()) / 60_000)),
  }));
}

function persistSelection(context: BusTimesContext): void {
  try {
    globalThis.localStorage?.setItem(
      STORAGE_KEY,
      JSON.stringify({
        routeId: context.selectedRouteId,
        directionId: context.selectedDirectionId,
        stopId: context.selectedStopId,
      }),
    );
  } catch {
    // Private browsing and blocked storage are valid operating environments.
  }
}

function readSelection(): { routeId: string; directionId: string; stopId: string } | null {
  try {
    const raw = globalThis.localStorage?.getItem(STORAGE_KEY);
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (typeof value !== 'object' || value === null) return null;
    const record = value as Record<string, unknown>;
    if (
      typeof record.routeId !== 'string' ||
      typeof record.directionId !== 'string' ||
      typeof record.stopId !== 'string'
    )
      return null;
    return { routeId: record.routeId, directionId: record.directionId, stopId: record.stopId };
  } catch {
    return null;
  }
}

const machine = setup({
  types: {
    context: {} as BusTimesContext,
    events: {} as BusTimesEvent,
  },
  guards: {
    hasSelection: ({ context }) => selectionIsValid(context),
    canChooseStop: ({ context, event }) =>
      event.type === 'bus-times.choose-stop' && selectionIsValid({ ...context, selectedStopId: event.stopId }),
  },
  actions: {
    persistSelection: ({ context }) => persistSelection(context),
    restoreSelection: assign(({ context }) => {
      const saved = readSelection();
      if (!saved) return {};
      const restored = {
        ...context,
        selectedRouteId: saved.routeId,
        selectedDirectionId: saved.directionId,
        selectedStopId: saved.stopId,
      };
      if (!selectionIsValid(restored)) return {};
      const route = context.routes.find((item) => item.id === saved.routeId);
      const direction = route?.directions.find((item) => item.id === saved.directionId);
      return { ...restored, directions: route?.directions ?? [], stops: direction?.stops ?? [] };
    }),
    refreshArrivals: assign(({ context }) => ({
      arrivals: upcomingArrivals(context),
      scheduleArrivals: upcomingArrivals(context),
      serviceDate: new Date().toISOString(),
      refreshedAt: new Date().toISOString(),
    })),
    chooseRoute: assign(({ context, event }) => {
      if (event.type !== 'bus-times.choose-route') return {};
      const route = context.routes.find((item) => item.id === event.routeId);
      return {
        selectedRouteId: route?.id ?? null,
        selectedDirectionId: null,
        selectedStopId: null,
        arrivals: [],
        scheduleArrivals: [],
        directions: route?.directions ?? [],
        stops: [],
        serviceDate: null,
        refreshedAt: null,
      };
    }),
    chooseDirection: assign(({ context, event }) => {
      if (event.type !== 'bus-times.choose-direction') return {};
      const route = context.routes.find((item) => item.id === context.selectedRouteId);
      const direction = route?.directions.find((item) => item.id === event.directionId);
      return {
        selectedDirectionId: direction?.id ?? null,
        selectedStopId: null,
        arrivals: [],
        scheduleArrivals: [],
        stops: direction?.stops ?? [],
        serviceDate: null,
        refreshedAt: null,
      };
    }),
    chooseStop: assign(({ context, event }) => {
      if (event.type !== 'bus-times.choose-stop') return {};
      const stop = selectedStop({ ...context, selectedStopId: event.stopId });
      return {
        selectedStopId: stop?.id ?? null,
        arrivals: [],
        scheduleArrivals: [],
        serviceDate: null,
        refreshedAt: null,
      };
    }),
  },
});

export const busTimesMachine = machine.createMachine({
  id: 'bus-times',
  initial: 'choosing',
  context: {
    routes: BUS_ROUTES,
    directions: [],
    stops: [],
    selectedRouteId: null,
    selectedDirectionId: null,
    selectedStopId: null,
    arrivals: [],
    scheduleArrivals: [],
    serviceDate: null,
    refreshedAt: null,
  },
  states: {
    choosing: {
      on: {
        'bus-times.choose-route': { actions: ['chooseRoute', 'persistSelection'] },
        'bus-times.choose-direction': { actions: ['chooseDirection', 'persistSelection'] },
        'bus-times.choose-stop': [
          { guard: 'canChooseStop', target: 'ready', actions: ['chooseStop', 'refreshArrivals', 'persistSelection'] },
          { actions: ['chooseStop', 'persistSelection'] },
        ],
        'bus-times.view-schedule': { guard: 'hasSelection', target: 'ready', actions: 'refreshArrivals' },
        'bus-times.refresh-schedule': { guard: 'hasSelection', target: 'ready', actions: 'refreshArrivals' },
        'bus-times.recall-stop': { actions: 'restoreSelection' },
      },
    },
    loading: {
      on: {
        'bus-times.view-schedule': { target: 'ready', actions: 'refreshArrivals' },
        'bus-times.refresh-schedule': { target: 'ready', actions: 'refreshArrivals' },
      },
    },
    ready: {
      on: {
        'bus-times.choose-route': { target: 'choosing', actions: ['chooseRoute', 'persistSelection'] },
        'bus-times.choose-direction': { target: 'choosing', actions: ['chooseDirection', 'persistSelection'] },
        'bus-times.choose-stop': { actions: ['chooseStop', 'refreshArrivals', 'persistSelection'] },
        'bus-times.view-schedule': { actions: 'refreshArrivals' },
        'bus-times.refresh-schedule': { actions: 'refreshArrivals' },
        'bus-times.recall-stop': { actions: 'restoreSelection' },
      },
    },
  },
});
